import React from 'react';
import { downloadExcel } from '../../../../utils/excel';

/**
 * Search, export and row-selection filtering for the client's stores ("Filtrar Datos" narrows the
 * profile's audits to the selected stores; "Quitar Filtro" restores them).
 */
export function useStoresTable({ stores, setFiltered, filtered, setSelectedStores, selectedStores, storeChecks, setStoreChecks }) {
    const [suggestions, setSuggestions] = React.useState([]);
    const [rowKeys, setRowKeys] = React.useState([]);

    const onSearch = (search) => {
        try {
            if (!search || typeof search !== 'string') {
                setSuggestions([]);
                setFiltered(stores || []);
                return;
            }

            const filteredData = stores?.filter((c) => c.name && c.name.toLowerCase().includes(search.toLowerCase())) || [];
            setSuggestions(filteredData.map((c) => c.name));
            setFiltered(filteredData);
        } catch (error) {
            console.warn('Error in stores search:', error);
            setSuggestions([]);
        }
    };

    const download = () => {
        const titles = ['Nombre', 'RIF', 'Tipo de PDV', 'Coordenada'];
        const data = stores.map((store) => ({
            Nombre: store.name,
            RIF: store.rif,
            'Tipo de PDV': store.storeType,
            Coordenada: store?.coordinates ? `${store?.coordinates?.latitude}, ${store?.coordinates?.longitude}` : '- -'
        }));
        downloadExcel(titles, data, 'Pisos de Venta');
    };

    const onFilter = () => {
        let selected = selectedStores;

        if (!storeChecks.length && !rowKeys.length) return;
        if (selectedStores.length === 0 || storeChecks.length > selectedStores.length) selected = storeChecks;

        const audits = selected.filter((check) => rowKeys.includes(check.storeId?._id));

        setSelectedStores(selected);
        setStoreChecks(audits);
    };

    const removeFilter = () => {
        setStoreChecks(selectedStores);
        setSelectedStores([]);
        setRowKeys([]);
    };

    const onSelectChange = (newSelectedRowKeys) => {
        setRowKeys(newSelectedRowKeys);
    };

    const storesSelection = {
        selectedRowKeys: rowKeys,
        onChange: onSelectChange
    };

    const dataWithKeys = filtered?.map((store) => ({
        ...store,
        key: store._id
    }));

    return { suggestions, rowKeys, onSearch, download, onFilter, removeFilter, storesSelection, dataWithKeys };
}
